(function () {
  function getProductData() {
    var el = document.getElementById('ProductJson-product-template');
    if (!el) return null;

    try {
      return JSON.parse(el.textContent);
    } catch (error) {
      return null;
    }
  }

  function getSelectedVariant(product) {
    var selects = document.querySelectorAll('.single-option-selector-product-template');
    var options = [];

    for (var i = 0; i < selects.length; i++) {
      options.push({
        value: selects[i].value,
        index: selects[i].getAttribute('data-index'),
      });
    }

    for (var v = 0; v < product.variants.length; v++) {
      var variant = product.variants[v];
      var match = true;

      for (var o = 0; o < options.length; o++) {
        if (variant[options[o].index] !== options[o].value) {
          match = false;
          break;
        }
      }

      if (match) return variant;
    }

    return null;
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function updateVariantDisplay() {
    var product = getProductData();
    if (!product) return;

    var variant = getSelectedVariant(product);
    if (!variant) return;

    var priceEl = document.getElementById('ProductPrice-product-template');
    if (priceEl) {
      priceEl.textContent = formatMoney(variant.price);
      priceEl.setAttribute('content', (variant.price / 100).toFixed(2));
    }

    var master = document.querySelector('[name="id"]');
    if (master) master.value = String(variant.id);

    if (typeof window.calcPriceWithCutItems === 'function') {
      window.calcPriceWithCutItems();
    }
  }

  function restoreThemeVariantPricing() {
    if (!window.themeLodash || typeof window.themeLodash.map !== 'function') {
      return false;
    }

    window._ = window.themeLodash;

    if (!window.jQuery || !window.theme || !theme.Product) {
      return false;
    }

    var $container = window.jQuery('[data-section-type="product"]');
    if (!$container.length) return false;

    try {
      new theme.Product($container[0]);
      updateVariantDisplay();
      return true;
    } catch (error) {
      return false;
    }
  }

  function bindVariantFix() {
    document.addEventListener('change', function (event) {
      var target = event.target;
      if (
        target &&
        target.classList &&
        target.classList.contains('single-option-selector-product-template')
      ) {
        if (!restoreThemeVariantPricing()) {
          updateVariantDisplay();
        }
      }
    });

    if (!restoreThemeVariantPricing()) {
      updateVariantDisplay();
    }
  }

  function scheduleFix() {
    bindVariantFix();
    setTimeout(function () {
      if (!restoreThemeVariantPricing()) updateVariantDisplay();
    }, 300);
    setTimeout(function () {
      if (!restoreThemeVariantPricing()) updateVariantDisplay();
    }, 1500);
    setTimeout(updateVariantDisplay, 3000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleFix);
  } else {
    scheduleFix();
  }

  window.addEventListener('load', function () {
    if (!restoreThemeVariantPricing()) updateVariantDisplay();
  });
})();
